
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special/private-healthcare",
      function () {
        return require("private-next-pages/special/private-healthcare/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/special/private-healthcare"])
      });
    }
  